import { render } from "./RolesManagerView.vue?vue&type=template&id=5c7a08e7"
import script from "./RolesManagerView.vue?vue&type=script&lang=js"
export * from "./RolesManagerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__